import React, { forwardRef } from "react";
import { SearchInputProps } from "../../types/search";
import "../../styles.css";

/**
 * SearchInput - Controlled search input component
 *
 * This component is a controlled input that displays search state.
 * It receives value and onChange props from parent and can trigger clear action.
 *
 * Features:
 * - Fully controlled component
 * - Search icon
 * - Clear button that appears when there's text
 * - Forward ref to underlying input element
 */
const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      value = "",
      placeholder = "What do you want to find?",
      onChange,
      disabled = false,
      onClear, // Optional clear callback
    },
    ref
  ) => {
    const hasValue = value.trim().length > 0;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value;
      if (onChange) {
        onChange(newValue);
      }
    };

    const handleClear = () => {
      if (onChange) {
        onChange("");
      }
      if (onClear) {
        onClear();
      }
    };

    return (
      <div className="search-input-container p-2 ">
        <input
          ref={ref}
          type="text"
          className="search-modal-input "
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          aria-label="Search input"
        />
        {/* Clear button - visible when there's text */}
        <button
          type="button"
          className="search-clear-button"
          aria-label="Clear search"
          style={{ visibility: hasValue ? "visible" : "hidden" }}
          onClick={handleClear}
          disabled={disabled}
        >
          <img src="src/img/x.svg" />
        </button>
        <button type="button" className="search-button" aria-label="Search">
          <img src="src/img/search-lg.svg" />
        </button>
      </div>
    );
  }
);

SearchInput.displayName = "SearchInput";

export default SearchInput;
